"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const common_utils_1 = require("@zapier/common-utils");
const generateZapTitleFromQuery = ({ query }) => {
    if (!query || !query.headActionLabel || !query.tailActionLabel) {
        return '';
    }
    const { headServiceId, headServiceName, headActionLabel, tailServiceId, tailServiceName, tailActionLabel, } = query;
    if (headServiceId === tailServiceId) {
        return `${lodash_1.default.upperFirst(common_utils_1.toLowerCaseString(tailActionLabel))} in ${headServiceName || ''} when ${common_utils_1.toLowerCaseString(headActionLabel)}`;
    }
    return `${lodash_1.default.upperFirst(common_utils_1.toLowerCaseString(tailActionLabel))} in ${tailServiceName || ''} when ${common_utils_1.toLowerCaseString(headActionLabel)} in ${headServiceName || ''}`;
};
exports.default = generateZapTitleFromQuery;
